import React from 'react';
import './nav.scss';
import  Globals from '../../api' ;
import { Nav , NavDropdown, Link  } from 'react-bootstrap';

export default class Navigation extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            
            headerData : []
         };
      }
      componentDidMount(){
        
        const HeaderConurl= Globals.Desktop_header_based_api;
        //console.log(HeaderConurl)
        fetch(HeaderConurl)
        .then((res) => res.json())
        .then((data) => {
            //console.log(data)
            this.setState({
                headerData :data.NavigationMenu.Items
              
            })
        }) 

      }
    render() {
        let CurrentUrl = window.location.pathname+window.location.hash;
        //console.log(window.location)  
 //navmenu 
 let _navmenu = this.state.headerData; 
   const NavMenu = _navmenu.map((item, i ) => 
   {
    return(
   
       <li  id={i} key={i}  className={CurrentUrl == item.DefaultUrl ? "active " : ""  } className={item.Items.length>0 ? "dropdown" : "" }><a href={item.DefaultUrl}>{item.Text}</a>
       {(() => {
                if (item.Items.length> 0 ) {
                  return (
                    <ul className="wd_dropdown">
                    {
                        item.Items.map((item, i) =>
                        
                        <a  key={i} href={item.DefaultUrl}>{item.Text}</a>
                        )
                    }
                </ul>
                  )
                }
              })()}
     </li>
   )});
   
        
        return (
        
            <div className="wd_navigation" >

                <Nav>
                    <ul>
                        { NavMenu }

                    </ul>
                </Nav>

                
                
            </div>
        )
    }
}